import {LabelPicker, type LabelPickerLabel} from '@github-ui/item-picker-label-tsq'

import {LABELS} from '../../constants/labels'
import {SectionHeader} from '../SectionHeader'
import {LabelsSection, ReadonlyLabelsSectionHeader} from './LabelsSection'

type CreateIssueLabelsSectionProps = {
  repo: string
  owner: string
  readonly: boolean
  canCreateLabel: boolean
  labels: LabelPickerLabel[]
  onSelectionChange: (labels: LabelPickerLabel[]) => void
}
export const CreateIssueLabelsSection = ({
  repo,
  owner,
  readonly,
  canCreateLabel,
  labels,
  onSelectionChange,
  ...sharedConfigProps
}: CreateIssueLabelsSectionProps) => {
  const sectionHeader = readonly ? (
    <ReadonlyLabelsSectionHeader />
  ) : (
    <LabelPicker
      repo={repo}
      owner={owner}
      readonly={readonly}
      canCreateLabel={canCreateLabel}
      labels={labels}
      onSelectionChange={onSelectionChange}
      showNoMatchItem
      enableSuggestedLabels
      anchorElement={(anchorProps, ref) => (
        <SectionHeader title={LABELS.sectionTitles.labels} buttonProps={anchorProps} ref={ref} />
      )}
      {...sharedConfigProps}
    />
  )
  return <LabelsSection sectionHeader={sectionHeader} labels={labels} />
}
